/**
 * Canonical option lists for the "Create Exercises" Paladin-style form.
 *
 * + Custom values entered by the coach are persisted server-side in the
 * `coach_custom_options` collection and merged into these lists at render time.
 */

// Disciplines (top tab)
export const DISCIPLINES = [
    { value: "strength", label: "Strength" },
    { value: "speed_power", label: "Speed/Power" },
];

// RM options for Strength tab (multi-select chips)
export const RM_OPTIONS = [
    "1RM", "2RM", "3RM", "4RM", "5RM", "6RM", "7RM", "8RM", "9RM", "10RM",
    "11RM", "12RM", "13RM", "14RM", "15RM", "16RM", "17RM", "18RM", "19RM", "20RM",
];

// Accel / Velocity parameters for Strength tab (multi-select chips)
export const VELOCITY_PARAMS = ["TpV", "pV", "aV"];

// Bar equipment for Strength tab (multi-select chips)
export const STRENGTH_EQUIPMENT_BAR = [
    "Straight Bar",
    "Trap Bar",
    "Safety Squat Bar",
    "Cambered Bar",
    "EZ Curl Bar",
];

// Other (non-bar) equipment for Strength tab (multi-select chips)
export const STRENGTH_EQUIPMENT_OTHER = [
    "Bench",
    "Box",
    "Pad",
    "Chains",
    "Bands",
    "Dumbbells",
    "Kettlebell",
    "Cable",
    "Bodyweight",
];

// Fly Ins for Speed/Power tab (multi-select chips)
export const FLY_INS = [
    "5 yard fly", "10 yard fly", "15 yard fly", "20 yard fly", "25 yard fly",
    "30 yard fly", "35 yard fly", "40 yard fly", "45 yard fly", "60 yard fly",
];

// Stance options for Speed/Power tab (multi-select chips)
export const STANCES = [
    "2 Point Stance",
    "3 Point Stance",
    "4 Point Stance",
    "2 Point Sideways Stance",
];

// Movement pattern (Category section) — different per discipline (single-select)
export const MOVEMENT_PATTERNS = {
    strength: ["Squat", "Single Legged", "Hinge", "Push", "Pull", "Rotate", "Brace"],
    speed_power: ["Sprint", "Jump", "Throw", "Land"],
};

// Order of Naming tokens — different per discipline
export const NAMING_TOKENS = {
    strength: ["RM", "Equipment", "Exercise Name", "Category", "Velocity"],
    speed_power: ["Fly In", "Stance", "Exercise Name", "Category"],
};

// Default order of naming per discipline
export const DEFAULT_NAMING_ORDER = {
    strength: ["RM", "Equipment", "Exercise Name", "Category"],
    speed_power: ["Fly In", "Stance", "Exercise Name"],
};

/**
 * Auto-map a Paladin (discipline, movement_pattern) pair to MaxSC's 5S category.
 * Used to keep the workout builder / athlete filters consistent.
 */
export function fiveSCategoryFor(discipline, movement_pattern) {
    if (discipline === "strength") return "strength";
    if (discipline === "speed_power") {
        const mp = (movement_pattern || "").toLowerCase();
        if (mp === "sprint") return "speed";
        return "skill"; // Jump / Throw / Land
    }
    return "strength";
}

/** Legacy exercise_type field for plate-calculator / runner. */
export function legacyExerciseTypeFor(discipline, movement_pattern) {
    if (discipline === "strength") return "compound";
    const mp = (movement_pattern || "").toLowerCase();
    if (mp === "sprint") return "speed";
    if (mp === "jump" || mp === "land") return "plyo";
    if (mp === "throw") return "power";
    return "speed";
}
